import { render, staticRenderFns } from "./TwoPhaseGASetting.vue?vue&type=template&id=ea7529e8&scoped=true&"
import script from "./TwoPhaseGASetting.vue?vue&type=script&lang=js&"
export * from "./TwoPhaseGASetting.vue?vue&type=script&lang=js&"
import style0 from "./TwoPhaseGASetting.vue?vue&type=style&index=0&id=ea7529e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7529e8",
  null
  
)

export default component.exports